import { ChildProps } from '@apollo/client/react/hoc';
import React from 'react';

import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { CSP, SearchPriceGuideToolTransactionGraph } from '@reverbdotcom/commons/src/rql';

import {
  QUERY,
  SELLER_COUNTRY_CODES,
  PAID_TRANSACTION_STATUSES,
  createdAfterSixMonthsAgoDate,
} from '../../show/price_guide_tool_transaction_graph_container';
import V2CSPPriceGuideModuleGraphAndTableContainer from './v2_csp_price_guide_module_graph_and_table_container';
import V2CSPPriceGuideModuleTableContainer from './v2_csp_price_guide_module_table_container';

export const V2_ORDER_THRESHOLD_FOR_GRAPH_AND_TABLE = 1;
interface IExternalProps {
  csp: CSP,
  canonicalProductIds: string[];
  conditionUuids: string[];
}

type IProps = ChildProps<IExternalProps, SearchPriceGuideToolTransactionGraph.Query>;

export function V2CSPPriceGuideModuleOrdersContainer({ 
  csp,
  canonicalProductIds,
  conditionUuids,
  data,
}: IProps) {
  const { loading, priceRecordsSearch = {} } = data;
  const { averageMonthlyProductPrices: productPrices = [] } = priceRecordsSearch;
  const totalOrdersOverSixMonths = productPrices.reduce((acc, field) => acc + field.docCount, 0);

  if (loading) return null;

  return (
    <>
      {totalOrdersOverSixMonths >= V2_ORDER_THRESHOLD_FOR_GRAPH_AND_TABLE ? (
        <V2CSPPriceGuideModuleGraphAndTableContainer
          csp={csp} 
          canonicalProductIds={canonicalProductIds} 
          conditionUuids={conditionUuids}
        />
      ) : (
        <V2CSPPriceGuideModuleTableContainer
          csp={csp} 
          canonicalProductIds={canonicalProductIds} 
          conditionUuids={conditionUuids}
        />
      )}
    </>
  );
}


const withQuery = withGraphql<IProps, SearchPriceGuideToolTransactionGraph.Query>(
  QUERY,
  {
    options: ({ canonicalProductIds, conditionUuids }) => {
      return {
        ssr: false,
        fetchPolicy: 'network-only',
        variables: {
          canonicalProductIds,
          conditionUuids,
          sellerCountries: SELLER_COUNTRY_CODES,
          createdAfterDate: createdAfterSixMonthsAgoDate(),
          actionableStatuses: PAID_TRANSACTION_STATUSES,
        },
      };
    },
  },
);

export default withQuery(V2CSPPriceGuideModuleOrdersContainer);
